import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { QRCodeCanvas } from 'qrcode.react';

const API_URL = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:5001';

const WhatsAppGroups = () => {
    const [groups, setGroups] = useState([]);
    const [stats, setStats] = useState({ total: 0, active: 0, full: 0, totalClicks: 0 });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editingGroup, setEditingGroup] = useState(null);

    // Form State
    const [formData, setFormData] = useState({
        name: '',
        inviteLink: '',
        clickLimit: 800,
        priority: 1,
        isActive: true
    });

    const ROTATOR_LINK = `${API_URL}/join-whatsapp`;

    useEffect(() => {
        fetchGroups();
    }, []);

    const fetchGroups = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_URL}/api/whatsapp-groups`);
            setGroups(response.data.groups || []);
            setStats(response.data.stats || { total: 0, active: 0, full: 0, totalClicks: 0 });
            setError(null);
        } catch (err) {
            console.error('Erro ao buscar grupos:', err);
            setError('Erro ao carregar grupos. Verifique se o servidor está rodando.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingGroup) {
                await axios.put(`${API_URL}/api/whatsapp-groups/${editingGroup.id}`, formData);
                alert('Grupo atualizado com sucesso!');
            } else {
                await axios.post(`${API_URL}/api/whatsapp-groups`, formData);
                alert('Grupo criado com sucesso!');
            }
            setShowModal(false);
            setEditingGroup(null);
            resetForm();
            fetchGroups();
        } catch (err) {
            alert('Erro ao salvar grupo: ' + (err.response?.data?.error || err.message));
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja remover este grupo?')) {
            try {
                await axios.delete(`${API_URL}/api/whatsapp-groups/${id}`);
                fetchGroups();
            } catch (err) {
                alert('Erro ao deletar grupo');
            }
        }
    };

    const handleReset = async (id) => {
        if (window.confirm('Deseja zerar o contador de cliques deste grupo? Ele será marcado como não-cheio.')) {
            try {
                await axios.post(`${API_URL}/api/whatsapp-groups/${id}/reset`);
                fetchGroups();
            } catch (err) {
                alert('Erro ao resetar grupo');
            }
        }
    };

    const openEditModal = (group) => {
        setEditingGroup(group);
        setFormData({
            name: group.name,
            inviteLink: group.inviteLink,
            clickLimit: group.clickLimit,
            priority: group.priority || 1,
            isActive: group.isActive
        });
        setShowModal(true);
    };

    const openCreateModal = () => {
        setEditingGroup(null);
        resetForm();
        setShowModal(true);
    };

    const resetForm = () => {
        setFormData({
            name: '',
            inviteLink: '',
            clickLimit: 800,
            priority: 1,
            isActive: true
        });
    };

    const downloadQRCode = () => {
        const canvas = document.getElementById('qr-code-canvas');
        if (canvas) {
            const pngUrl = canvas.toDataURL("image/png");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "whatsapp-group-rotator-qr.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    const copyLink = () => {
        navigator.clipboard.writeText(ROTATOR_LINK);
        alert('Link copiado para a área de transferência!');
    };

    if (loading && groups.length === 0) return <div className="p-4 text-center">Carregando...</div>;

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ color: '#2d3277', margin: 0 }}><i className="fab fa-whatsapp"></i> Rotacionador de Grupos</h2>
                <button className="btn-primary" onClick={openCreateModal}>
                    <i className="fas fa-plus"></i> Novo Grupo
                </button>
            </div>

            {/* Stats Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '30px' }}>
                <div style={cardStyle}>
                    <h3 style={cardTitleStyle}>Total de Grupos</h3>
                    <p style={cardValueStyle}>{stats.total}</p>
                </div>
                <div style={cardStyle}>
                    <h3 style={cardTitleStyle}>Grupos Ativos</h3>
                    <p style={{ ...cardValueStyle, color: '#28a745' }}>{stats.active}</p>
                </div>
                <div style={cardStyle}>
                    <h3 style={cardTitleStyle}>Grupos Cheios</h3>
                    <p style={{ ...cardValueStyle, color: '#dc3545' }}>{stats.full}</p>
                </div>
                <div style={cardStyle}>
                    <h3 style={cardTitleStyle}>Total de Cliques</h3>
                    <p style={{ ...cardValueStyle, color: '#007bff' }}>{stats.totalClicks}</p>
                </div>
            </div>

            {/* Master Link & QR Code Section */}
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginBottom: '30px',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                alignItems: 'center'
            }}>
                <div style={{ flex: 1, minWidth: '300px' }}>
                    <h3 style={{ marginTop: 0, color: '#2d3277' }}>🔗 Link Mestre (Rotacionador)</h3>
                    <p style={{ color: '#666', marginBottom: '15px' }}>
                        Use este link em seus botões e campanhas. O sistema irá redirecionar automaticamente para um grupo disponível.
                    </p>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                        <input
                            type="text"
                            readOnly
                            value={ROTATOR_LINK}
                            style={{
                                flex: 1,
                                padding: '10px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                backgroundColor: '#f8f9fa',
                                color: '#333'
                            }}
                        />
                        <button onClick={copyLink} className="btn-secondary" title="Copiar Link">
                            <i className="fas fa-copy"></i> Copiar
                        </button>
                    </div>
                    <div style={{ fontSize: '0.9rem', color: '#666' }}>
                        <i className="fas fa-info-circle"></i> <strong>Dica:</strong> Se todos os grupos estiverem cheios, o usuário verá uma página de aviso.
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '15px',
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    backgroundColor: '#fff'
                }}>
                    <div style={{ marginBottom: '10px', background: 'white', padding: '10px' }}>
                        <QRCodeCanvas
                            id="qr-code-canvas"
                            value={ROTATOR_LINK}
                            size={150}
                            level={"H"}
                            includeMargin={true}
                        />
                    </div>
                    <button onClick={downloadQRCode} className="btn-secondary" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-download"></i> Baixar QR Code
                    </button>
                </div>
            </div>

            {/* Groups List */}
            <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                        <tr>
                            <th style={thStyle}>Status</th>
                            <th style={thStyle}>Nome</th>
                            <th style={thStyle}>Cliques / Limite</th>
                            <th style={thStyle}>Prioridade</th>
                            <th style={thStyle}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groups.map(group => {
                            const percentage = Math.round((group.clicksCount / group.clickLimit) * 100);
                            const isFull = group.isFull || group.clicksCount >= group.clickLimit;

                            return (
                                <tr key={group.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                                    <td style={tdStyle}>
                                        {isFull ? (
                                            <span style={{ ...badgeStyle, backgroundColor: '#dc3545' }}>CHEIO</span>
                                        ) : !group.isActive ? (
                                            <span style={{ ...badgeStyle, backgroundColor: '#6c757d' }}>INATIVO</span>
                                        ) : (
                                            <span style={{ ...badgeStyle, backgroundColor: '#28a745' }}>ATIVO</span>
                                        )}
                                    </td>
                                    <td style={tdStyle}>
                                        <strong>{group.name}</strong>
                                        <br />
                                        <a href={group.inviteLink} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem', color: '#007bff' }}>
                                            Link Original <i className="fas fa-external-link-alt"></i>
                                        </a>
                                    </td>
                                    <td style={tdStyle}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ flex: 1, maxWidth: '150px' }}>
                                                <div style={{ fontSize: '0.9rem', marginBottom: '4px' }}>
                                                    {group.clicksCount} / {group.clickLimit} ({percentage}%)
                                                </div>
                                                <div style={{ width: '100%', height: '6px', backgroundColor: '#e9ecef', borderRadius: '3px' }}>
                                                    <div style={{
                                                        width: `${Math.min(percentage, 100)}%`,
                                                        height: '100%',
                                                        backgroundColor: isFull ? '#dc3545' : percentage > 80 ? '#ffc107' : '#28a745',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={tdStyle}>{group.priority}</td>
                                    <td style={tdStyle}>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <button onClick={() => openEditModal(group)} className="btn-icon" title="Editar">
                                                <i className="fas fa-edit"></i>
                                            </button>
                                            <button onClick={() => handleReset(group.id)} className="btn-icon" title="Zerar Contador">
                                                <i className="fas fa-sync-alt"></i>
                                            </button>
                                            <button onClick={() => handleDelete(group.id)} className="btn-icon delete" title="Excluir">
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        {groups.length === 0 && (
                            <tr>
                                <td colSpan="5" style={{ padding: '30px', textAlign: 'center', color: '#666' }}>
                                    Nenhum grupo cadastrado. Clique em "Novo Grupo" para começar.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal */}
            {showModal && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>
                        <h3 style={{ marginTop: 0 }}>{editingGroup ? 'Editar Grupo' : 'Novo Grupo'}</h3>
                        <form onSubmit={handleSubmit}>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Nome do Grupo</label>
                                <input
                                    type="text"
                                    value={formData.name}
                                    onChange={e => setFormData({ ...formData, name: e.target.value })}
                                    required
                                    style={inputStyle}
                                    placeholder="Ex: Promoções VIP 01"
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label style={labelStyle}>Link de Convite (WhatsApp)</label>
                                <input
                                    type="url"
                                    value={formData.inviteLink}
                                    onChange={e => setFormData({ ...formData, inviteLink: e.target.value })}
                                    required
                                    style={inputStyle}
                                    placeholder="https://chat.whatsapp.com/..."
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ ...formGroupStyle, flex: 1 }}>
                                    <label style={labelStyle}>Limite de Cliques</label>
                                    <input
                                        type="number"
                                        value={formData.clickLimit}
                                        onChange={e => setFormData({ ...formData, clickLimit: parseInt(e.target.value) })}
                                        required
                                        style={inputStyle}
                                    />
                                </div>
                                <div style={{ ...formGroupStyle, flex: 1 }}>
                                    <label style={labelStyle}>Prioridade (1 = Alta)</label>
                                    <input
                                        type="number"
                                        value={formData.priority}
                                        onChange={e => setFormData({ ...formData, priority: parseInt(e.target.value) })}
                                        required
                                        style={inputStyle}
                                    />
                                </div>
                            </div>
                            <div style={formGroupStyle}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        checked={formData.isActive}
                                        onChange={e => setFormData({ ...formData, isActive: e.target.checked })}
                                    />
                                    Grupo Ativo (Receber cliques)
                                </label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">Cancelar</button>
                                <button type="submit" className="btn-primary">Salvar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

// Styles
const cardStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    textAlign: 'center'
};

const cardTitleStyle = {
    margin: '0 0 10px 0',
    fontSize: '0.9rem',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
};

const cardValueStyle = {
    margin: 0,
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#2d3277'
};

const thStyle = {
    padding: '15px',
    textAlign: 'left',
    fontSize: '0.9rem',
    color: '#666',
    fontWeight: '600'
};

const tdStyle = {
    padding: '15px',
    verticalAlign: 'middle'
};

const badgeStyle = {
    padding: '4px 8px',
    borderRadius: '4px',
    color: 'white',
    fontSize: '0.75rem',
    fontWeight: 'bold'
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
};

const modalContentStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '500px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
};

const formGroupStyle = {
    marginBottom: '15px'
};

const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: '500',
    color: '#333'
};

const inputStyle = {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    fontSize: '1rem'
};

export default WhatsAppGroups;
